import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import {User} from 'main/stores/users';

class AnnouncementComment extends DomainObject {
  id;
  content;
  createdAt;
  updatedAt;
  announcementId;

  _relations = {
    _dates: ['createdAt', 'updatedAt'],
    user: User
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      content: observable,
      createdAt: observable,
      updatedAt: observable,
      announcementId: observable
    });

    this.merge(other);
  }
}

export default AnnouncementComment;
